import { render, staticRenderFns } from "./TownPlanning.vue?vue&type=template&id=4a74bbea&"
import script from "./TownPlanning.vue?vue&type=script&lang=ts&"
export * from "./TownPlanning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports